export const POLLING_TIMEOUT = 10000;
